<a href="javascript:void(0)" *ngIf="policy && policy.lineOfBusinessId == 8 && maInsurance.vehicle.category && this.policyState == 'active'">
    <button nxButton="secondary small" (click)="generatePzpCard()" type="button" class="nx-margin-left-2xs">
      <span translate>policy.green-card</span>
    </button>
  </a>